import * as React from 'react';

const ArrowRightIcon = (props: any): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill="none" {...props}>
    <mask
      id="mask0_2696_1929"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={21}
    >
      <rect y={0.891846} width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2696_1929)">
      <path
        d="M11.1667 10.8919L5.29167 5.01693C5.09722 4.82248 5 4.58637 5 4.30859C5 4.03082 5.09722 3.7947 5.29167 3.60026C5.48611 3.40582 5.72222 3.30859 6 3.30859C6.27778 3.30859 6.51389 3.40582 6.70833 3.60026L12.9375 9.82943C13.0903 9.9822 13.2014 10.1489 13.2708 10.3294C13.3403 10.51 13.375 10.6975 13.375 10.8919C13.375 11.0864 13.3403 11.2739 13.2708 11.4544C13.2014 11.635 13.0903 11.8017 12.9375 11.9544L6.70833 18.1836C6.51389 18.378 6.27778 18.4753 6 18.4753C5.72222 18.4753 5.48611 18.378 5.29167 18.1836C5.09722 17.9891 5 17.753 5 17.4753C5 17.1975 5.09722 16.9614 5.29167 16.7669L11.1667 10.8919Z"
        fill={props.fillColor}
      />
    </g>
  </svg>
);

export default ArrowRightIcon;
